import * as yup from "yup";

const isValidEmail = (value: string) => yup.string().email().isValidSync(value);

interface Options {
  allowMailTo: boolean;
}

export const prependProtocol = (
  value: string,
  options: Options = { allowMailTo: false },
) => {
  if (!value) return value;

  const trimmedValue = value.trim();

  if (options.allowMailTo) {
    if (trimmedValue.toLowerCase().startsWith("mailto:")) return trimmedValue;
    if (isValidEmail(trimmedValue)) return `mailto:${trimmedValue}`;
  }

  if (/^https?:\/\/.*/i.test(trimmedValue)) return trimmedValue;

  return `https://${trimmedValue}`;
};
